<template>
  <teleport to="body">
    <transition name="back-to-top-fade">
      <a-button
        v-show="visible"
        type="primary"
        shape="circle"
        size="large"
        class="back-to-top-btn"
        :aria-label="'回到顶部'"
        @click="scrollTop"
      >
        <template #icon>
          <VerticalAlignTopOutlined />
        </template>
      </a-button>
    </transition>
  </teleport>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { VerticalAlignTopOutlined } from '@ant-design/icons-vue';

const visible = ref(false);
const threshold = 240;

/**
 * 取当前纵向滚动量（#app 或窗口，二者取较大）
 */
function getScrollY(): number {
  const app = document.getElementById('app');
  const appY = app ? app.scrollTop : 0;
  const winY =
    window.scrollY ||
    document.documentElement.scrollTop ||
    document.body.scrollTop;
  return appY > winY ? appY : winY;
}

/**
 * 根据滚动位置切换按钮显示
 */
function onScroll() {
  visible.value = getScrollY() > threshold;
}

/**
 * 平滑滚动到页面顶部
 */
function scrollTop() {
  const app = document.getElementById('app');
  if (app) {
    app.scrollTo({ top: 0, behavior: 'smooth' });
  }
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

onMounted(() => {
  onScroll();
  const app = document.getElementById('app');
  if (app) {
    app.addEventListener('scroll', onScroll, { passive: true });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
});

onUnmounted(() => {
  const app = document.getElementById('app');
  if (app) {
    app.removeEventListener('scroll', onScroll);
  }
  window.removeEventListener('scroll', onScroll);
});
</script>

<style scoped>
.back-to-top-btn {
  position: fixed;
  right: 28px;
  bottom: 96px;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.back-to-top-fade-enter-active,
.back-to-top-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.back-to-top-fade-enter-from,
.back-to-top-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
